export const findMapElementById = (mapElements, id) => {
  return mapElements.find((element) => element.id === id);
};

export const findIndexById = (mapElements, id) => {
  return mapElements.findIndex((element) => element.id === id);
};
